import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { Link } from 'react-router-dom'

import { connect } from 'react-redux'
import { login } from 'reducers/user/userActions'

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardHidden: true,
      username: "",
      password: "",
      usernameError: null,
      passwordError: null
    };
  }

  componentWillMount() {
    const queryParams = this.props.location.search;
    const params = new URLSearchParams(queryParams.replace("?", ""));

    const userName = params.get('username');

    console.log("username", userName);

    if (userName != null && userName !== "") {
      this.setState({
        username: userName
      });
    }
  }

  componentDidMount() {
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
  }

  handleUsernameChange(event) {
    this.setState({
      username: event.target.value
    });
    event.target.value.length == 0
      ? this.setUsernameError()
      : this.setState({ usernameError: null });
  }

  handlePasswordChange(event) {
    this.setState({
      password: event.target.value
    });
    event.target.value.length < 6
      ? this.setPasswordError()
      : this.setState({ passwordError: null });
  }

  setUsernameError() {
    this.setState({
      usernameError: (
        <small className="text-danger">
          El usuario es requerido
          </small>
      )
    })
  }

  setPasswordError() {
    this.setState({
      passwordError: (
        <small className="text-danger">
          Su contraseña debe tener al menos 6 caracters
          </small>
      )
    })
  }

  handleLogin() {
    if (this.state.username.length == 0) {
      this.setUsernameError(); return;
    } else {
      this.setState({ usernameError: null });
    }
    if (this.state.password.length < 6) {
      this.setPasswordError(); return;
    } else {
      this.setState({ passwordError: null });
    }

    let credentials = {
      username: this.state.username,
      password: this.state.password
    }

    this.props.login(credentials);

  }

  render() {
    return (
      <Grid>
        <Row>
          <Col md={4} sm={6} mdOffset={4} smOffset={3}>
            <form>
              <Card
                hidden={this.state.cardHidden}
                textCenter
                title="Inicio de sesión"
                content={
                  <div>
                    <FormGroup>
                      <ControlLabel>Usuario</ControlLabel>
                      <FormControl
                        placeholder="Ingresa Usuario"
                        name="user"
                        type="text"
                        value={this.state.username}
                        onChange={event => this.handleUsernameChange(event)}
                      />
                      {this.state.usernameError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Contraseña</ControlLabel>
                      <FormControl
                        placeholder="Contraseña"
                        name="password"
                        type="password"
                        onChange={event => this.handlePasswordChange(event)}
                      />
                      {this.state.passwordError}
                    </FormGroup>
                  </div>
                }
                legend={
                  <div>
                    <Button
                      bsStyle="info"
                      fill
                      wd
                      onClick={this.handleLogin.bind(this)}
                    >
                      Iniciar sesión
                  </Button> <br/>
                    <Link to="/pages/forgot-password">¿Has olvidado tu contraseña?</Link>
                  </div>
                }
                ftTextCenter
              />
            </form>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default connect(null, { login })(LoginPage);



// WEBPACK FOOTER //
// ./src/views/Pages/LoginPage.jsx